import { ButtonProps } from "primereact/button";
import { ColumnProps } from "primereact/column";
import { assetType, FaultAssetMapMaster, FormValues, IndentFormData, InspectionAssetMapMaster, InspectionReportPayload, InspectionTemplateMaster, ServiceReportPayload, ServiceTemplateMaster } from "../types/assetTypes";
import { faultTypes } from "../types/faultTypes";

// Helper functions to format dates and times
function formatDate(date: string | null | undefined): string {
  if (!date) return "";

  const d = new Date(date);
  if (isNaN(d.getTime())) return ""; // invalid date

  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const year = d.getFullYear();

  return `${year}-${month}-${day}`;
}


function formatTime(date: string) {
  const d = new Date(date);
  let hours = d.getHours();
  let minutes = String(d.getMinutes()).padStart(2, '0');
  const period = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  return `${hours}:${minutes} ${period}`;
}


export const getAssertButtonData = (
  clearFilter: () => void,
  overlayPanelRef: React.RefObject<any>,
  selectedProducts: any[],
  handleDeleteAll: (data: any) => void,
  openVisibilityPopover: (event: React.MouseEvent<HTMLElement>) => void,
  userDetails: { role: string[] }
): ButtonProps[] => [
    {
      type: "button",
      outlined: false,
      icon: "pi pi-filter-slash",
      label: "Clear",
      style: { marginRight: "2px", borderRadius: "3px", color: "#FFFFFF" },
      onClick: clearFilter, // Assign onClick for Clear
      title: "Clear Filter",
      text: true,
      raised: true,
    },

    ...(userDetails.role.includes("Admin") || userDetails.role.includes("Assets Write")
      ? [
        {
          label: "Add",
          icon: "pi pi-plus",
          severity: "success" as const,
          style: { marginRight: "2px", borderRadius: "3px" },
          onClick: (e: React.MouseEvent<HTMLElement>) => overlayPanelRef.current?.toggle(e),
          title: "Add New Asset",
          outlined: false,
          text: true,
          raised: true,
        },
      ]
      : []),
    {
      label: "Delete",
      icon: "pi pi-trash",
      style: { marginRight: '2px', borderRadius: "3px" },
      severity: "danger",
      disabled: !selectedProducts || selectedProducts.length === 0,
      title: "Delete Selected Asset",
      outlined: true,
      text: true,
      raised: true,
      onClick: (e) => handleDeleteAll(selectedProducts)
    },
    {
      type: "button",
      label: "Columns",
      icon: "pi pi-list",
      style: { marginRight: "2px", borderRadius: "3px", color: "#FFFFFF" },
      onClick: (e) => {
        openVisibilityPopover(e);
      },
      title: "Select Columns",
      outlined: false,
      text: true,
      raised: true,
      className: "column-btn"
    }

  ];

export const getStockButtonData = (
  clearFilter: () => void,
  overlayPanelRef: React.RefObject<any>,
  selectedProducts: any[],
  handleAddStock: () => void,
  openVisibilityPopover: (event: React.MouseEvent<HTMLElement>) => void // <-- Add this  
): ButtonProps[] => [
    {
      type: "button",
      outlined: false,
      icon: "pi pi-filter-slash",
      label: "Clear",
      style: { marginRight: "2px", borderRadius: "3px", color: "#FFFFFF" },
      onClick: clearFilter, // Assign onClick for Clear
      title: "Clear Filter",
      text: true,
      raised: true
    },
    {
      label: "Add",
      icon: "pi pi-plus",
      severity: "success",
      style: { marginRight: "2px", borderRadius: "3px" },
      onClick: handleAddStock, // Assign onClick for New
      title: "Add New Stock",
      outlined: false,
      text: true,
      raised: true
    },
    {
      type: "button",
      label: "Columns",
      icon: "pi pi-list",
      style: { marginRight: "2px", borderRadius: "3px" },
      onClick: (e) => {
        openVisibilityPopover(e);
      },
      title: "Select Columns",
      outlined: false,
      text: true,
      raised: true,
    }


  ];

export const getStockCodeDatabaseButtonData = (
  clearFilter: () => void,

  overlayPanelRef: React.RefObject<any>,
  selectedProducts: any[],
  openVisibilityPopover: (event: React.MouseEvent<HTMLElement>) => void // <-- Add this  
): ButtonProps[] => [
    {
      type: "button",
      label: "Columns",
      icon: "pi pi-list",
      style: { marginRight: "2px", borderRadius: "3px" },
      onClick: (e) => {
        openVisibilityPopover(e);
      },
      title: "Select Columns",
      outlined: false,
      text: true,
      raised: true,
    },
    {
      type: "button",
      outlined: false,
      icon: "pi pi-filter-slash",
      label: "Clear",
      style: { marginRight: "2px", borderRadius: "3px", color: "#FFFFFF" },
      onClick: clearFilter, // Assign onClick for Clear
      title: "Clear Filter",
      text: true,
      raised: true
    },




  ];






export const getStockInOutData = (
  clearFilter: () => void,
  exportCSV: (data: any) => void


): ButtonProps[] => [
    {
      type: "button",
      outlined: false,
      icon: "pi pi-filter-slash",
      label: "Clear",
      style: { marginRight: "2px", borderRadius: "3px", color: "#FFFFFF" },
      onClick: clearFilter, // Assign onClick for Clear
      title: "Clear Filter",
      text: true,
      raised: true
    },
    {
      label: "Export",
      icon: "pi pi-upload",
      style: { marginLeft: "2px", borderRadius: "3px" },
      onClick: exportCSV,
      outlined: true,
      text: true,
      raised: true,
      title: "Export Excel",
    },


  ];




export const assertBodyTableIcon = (
  handleEditAsset: (assetId: number, selectedFamily: number) => void,
  handleDeleteAsset: (assetId: number) => void,
  rowData: assetType
): ButtonProps[] => [
    {
      icon: "pi pi-pencil",
      rounded: true,
      outlined: true,
      className: "mr-2",
      onClick: () => handleEditAsset(rowData.assetId, rowData.familyAssetId),
      title: "Edit Asset",
    },
    {
      icon: "pi pi-trash",
      rounded: true,
      outlined: true,
      className: "mr-2",
      severity: 'danger',
      onClick: () => handleDeleteAsset(rowData.assetId),
      title: "Delete Asset",
    }
  ]


type ViewType = "all" | "drafts" | "submitted";
export const indentBodyTableIcon = (
  handleEditIndents: (indentId: number, indentPrimaryId: number) => void,
  handleViewIndent: (indentId: number, indentPrimaryId: number) => void,
  rowData: IndentFormData,
  viewType: "all" | "drafts" | "submitted"
): ButtonProps[] => {
  switch (viewType) {
    case "drafts":
      return [
        {
          icon: "pi pi-pencil",
          rounded: true,
          outlined: true,
          className: "mr-2",
          onClick: () => handleEditIndents(rowData.indentId, rowData.indentPrimaryId),
          title: "Edit Indent",
        },
      ];
    case "submitted":
      return [
        {
          icon: "pi pi-eye",
          rounded: true,
          outlined: true,
          className: "mr-2",
          onClick: () => handleViewIndent(rowData.indentId, rowData.indentPrimaryId),
          title: "View Indent",
        },
      ];
    case "all":
    default:
      return []; // No icons for 'all'
  }
};

// export const indentBodyTableIcon = (
//   handleEditIndents: (indentId: number) => void,

//   rowData: IndentFormData
// ): ButtonProps[] => [
//   {
//     icon: "pi pi-pencil",
//     rounded: true,
//     outlined: true, 
//     className: "mr-2",
//     onClick: ()=>handleEditIndents(rowData.indentId),
//     title: "Edit Asset",
//   },
//   // {
//   //   icon: "pi pi-trash",
//   //   rounded: true,
//   //   outlined: true, 
//   //   className: "mr-2",
//   //   severity: 'danger',
//   //   onClick: ()=>handleDeleteAsset(rowData.assetId),
//   //   title: "Delete Asset",
//   // }
// ]

export const templateBodyTableIcon = (
  handleEditServiceTemplate: (serviceTemplateId: ServiceTemplateMaster) => void,

  rowData: ServiceTemplateMaster
): ButtonProps[] => [
    {
      icon: "pi pi-pencil",
      rounded: true,
      outlined: true,
      className: "mr-2",
      onClick: () => handleEditServiceTemplate(rowData),
      title: "Edit Asset",
    },
    // {
    //   icon: "pi pi-trash",
    //   rounded: true,
    //   outlined: true, 
    //   className: "mr-2",
    //   severity: 'danger',
    //   onClick: ()=>handleDeleteAsset(rowData.assetId),
    //   title: "Delete Asset",
    // }
  ]

export const saveServiceBodyTableIcon = (
  handleEditSaveServiceTemplate: (serviceReportingId: number, rowData: ServiceReportPayload) => void,
  handleDeleteService: (serviceReportingId: number) => void,

  rowData: ServiceReportPayload
): ButtonProps[] => [
    {
      icon: "pi pi-pencil",
      rounded: true,
      outlined: true,
      className: "mr-2",
      onClick: () => handleEditSaveServiceTemplate(rowData.serviceReportingId, rowData),
      title: "Edit Serice Reporting",
    },
    {
      icon: "pi pi-trash",
      rounded: true,
      outlined: true,
      className: "mr-2",
      severity: 'danger',
      onClick: () => handleDeleteService(rowData.serviceReportingId),
      title: "Delete Asset",
    },

  ]

export const indentsTemplateTableIcon = (
  handleEditIndents: (indentTemplateId: number) => void,

  rowData: any
): ButtonProps[] => [
    {
      icon: "pi pi-pencil",
      rounded: true,
      outlined: true,
      className: "mr-2",
      onClick: () => handleEditIndents(rowData.indentTemplateId || 0),
      title: "Edit Serice Reporting",
    },
    //  {
    //   icon: "pi pi-trash",
    //   rounded: true,
    //   outlined: true, 
    //   className: "mr-2",
    //   severity: 'danger',
    //   onClick: ()=>handleDeleteService(rowData.serviceReportingId),
    //   title: "Delete Asset",
    // },

  ]

export const saveInspectionBodyTableIcon = (
  handleEditSaveInspectionTemplate: (inspectionReportingId: number, rowData: InspectionReportPayload) => void,
  handleDeleteInspection: (inspectionReportingId: number) => void,

  rowData: InspectionReportPayload
): ButtonProps[] => [
    {
      icon: "pi pi-pencil",
      rounded: true,
      outlined: true,
      className: "mr-2",
      onClick: () => handleEditSaveInspectionTemplate(rowData.inspectionReportingId, rowData),
      title: "Edit Serice Reporting",
    },
    {
      icon: "pi pi-trash",
      rounded: true,
      outlined: true,
      className: "mr-2",
      severity: 'danger',
      onClick: () => handleDeleteInspection(rowData.inspectionReportingId),
      title: "Delete Asset",
    },

  ]


export const assetMapBodyTableIcon = (
  handleEditServiceMap: (serviceAssetMapId: number, rowData: FaultAssetMapMaster) => void,

  rowData: FaultAssetMapMaster
): ButtonProps[] => [
    {
      icon: "pi pi-pencil",
      rounded: true,
      outlined: true,
      className: "mr-2",
      onClick: () => handleEditServiceMap(rowData.serviceAssetMapId, rowData),
      title: "Edit Serice Mapping",
    },
  ]



export const inspectionBodyTableIcon = (
  handleEditInspectionTemplate: (inspectionTemplateId: InspectionTemplateMaster) => void,

  rowData: InspectionTemplateMaster
): ButtonProps[] => [
    {
      icon: "pi pi-pencil",
      rounded: true,
      outlined: true,
      className: "mr-2",
      onClick: () => handleEditInspectionTemplate(rowData),
      title: "Edit Asset",
    },
    // {
    //   icon: "pi pi-trash",
    //   rounded: true,
    //   outlined: true, 
    //   className: "mr-2",
    //   severity: 'danger',
    //   onClick: ()=>handleDeleteAsset(rowData.assetId),
    //   title: "Delete Asset",
    // }
  ]

export const inspectionMapBodyTableIcon = (
  handleEditInspectionMap: (inspectionAssetMapId: number, rowData: InspectionAssetMapMaster) => void, // Function expects a number
  rowData: InspectionAssetMapMaster
): ButtonProps[] => [
    {
      icon: "pi pi-pencil",
      rounded: true,
      outlined: true,
      className: "mr-2",
      onClick: () => handleEditInspectionMap(rowData.inspectionAssetMapId, rowData), // Pass the ID correctly
      title: "Edit Service Mapping",
    },
  ];

export const getTemplateeButtonData = (
  clearFilter: () => void,
  handleAddClick: () => void,
  //openVisibilityPopover: (event: React.MouseEvent<HTMLElement>) => Promise<void> // Expect the function with the event argument
): ButtonProps[] => [
    {
      type: "button",
      outlined: false,
      icon: "pi pi-filter-slash",
      label: "Clear",
      style: { marginRight: "2px", borderRadius: "3px", color: "#FFFFFF" },
      onClick: clearFilter, // Assign onClick for Clear
      title: "Clear Filter",
      text: true,
      raised: true
    },
    {
      label: "Add",
      icon: "pi pi-plus",
      severity: "success",
      style: { marginRight: "2px", borderRadius: "3px" },
      onClick: handleAddClick, // Assign onClick for New
      title: "Add New",
      outlined: false,
      text: true,
      raised: true
    },

  ];


export const getTemplateButtonData = (
  clearFilter: () => void,
  handleAddClick: () => void,
  //openVisibilityPopover: (event: React.MouseEvent<HTMLElement>) => Promise<void> // Expect the function with the event argument
): ButtonProps[] => [
    {
      type: "button",
      outlined: false,
      icon: "pi pi-filter-slash",
      label: "Clear",
      style: { marginRight: "2px", borderRadius: "3px", color: "#FFFFFF" },
      onClick: clearFilter, // Assign onClick for Clear
      title: "Clear Filter",
      text: true,
      raised: true
    },
    {
      label: "Add",
      icon: "pi pi-plus",
      severity: "success",
      style: { marginRight: "2px", borderRadius: "3px" },
      onClick: handleAddClick, // Assign onClick for New
      title: "Add New",
      outlined: false,
      text: true,
      raised: true
    },
    // {
    //   label: "Columns",
    //   icon: "pi pi-list",
    //   style: { marginRight: "2px", borderRadius: "3px" },
    //   onClick: (event: React.MouseEvent<HTMLElement>) => openVisibilityPopover(event), // Pass event to openVisibilityPopover

    //   title: "Select Columns",
    //   outlined: false,
    //   text: true,
    //   raised: true,
    // },
    // {
    //   label:"",
    //   icon:"pi pi-trash",
    //   style:{marginRight:'2px', borderRadius:"3px"},
    //   severity:"danger",
    //   disabled: !selectedProducts || selectedProducts.length === 0,
    //   title: "Delete Selected Asset",
    //   outlined: true,
    //   text: true,
    //   raised: true,
    //   onClick: (e) => handleDeleteAll(selectedProducts)
    // }
  ];

// export const getIndentsButtonData = (
//   clearFilter: () => void,
//   handleAddClick: () => void,
//   openVisibilityPopover: (event: React.MouseEvent<HTMLElement>) => Promise<void> // Expect the function with the event argument
// ): ButtonProps[] => [
//   {
//     type: "button",
//     outlined: false,
//     icon: "pi pi-filter-slash",
//     label: "Clear",
//     style: { marginRight: "2px", borderRadius:"3px", color:"#FFFFFF" },
//     onClick: clearFilter, // Assign onClick for Clear
//     title: "Clear Filter",
//     text: true,
//     raised: true
//   },
//   {
//     label: "Add",
//     icon: "pi pi-plus",
//     severity: "success",
//     style: { marginRight: "2px", borderRadius:"3px" },
//     onClick: handleAddClick, // Assign onClick for New
//     title: "Add New",
//     outlined: false,
//     text: true,
//     raised: true
//   },
//   { 
//     type: "button",
//     label: "Columns",
//     icon: "pi pi-list",
//     style: { marginRight: "2px", borderRadius: "3px" },
//     onClick: (event: React.MouseEvent<HTMLElement>) => openVisibilityPopover(event), // Pass event to openVisibilityPopover

//     title: "Select Columns",
//     outlined: false,
//     text: true,
//     raised: true,
//   },
// {
//   label:"",
//   icon:"pi pi-trash",
//   style:{marginRight:'2px', borderRadius:"3px"},
//   severity:"danger",
//   disabled: !selectedProducts || selectedProducts.length === 0,
//   title: "Delete Selected Asset",
//   outlined: true,
//   text: true,
//   raised: true,
//   onClick: (e) => handleDeleteAll(selectedProducts)
// }
// ];


export const getIndentsTemplateData = (
  handleAddClick: () => void,
  userDetails: { role: string[] }
): ButtonProps[] => [
    ...(userDetails.role.includes("Admin") || userDetails.role.includes("Indents Write")
      ? [
        {
          label: "Add",
          icon: "pi pi-plus",
          severity: "success" as const,
          style: { marginRight: "2px", borderRadius: "3px" },
          onClick: handleAddClick,
          title: "Add New",
          outlined: false,
          text: true,
          raised: true
        }
      ]
      : [])
  ];



export const getIndentsButtonData = (
  clearFilter: () => void,
  handleAddClick: () => void,
  openVisibilityPopover: (event: React.MouseEvent<HTMLElement>) => Promise<void>,
  handleDraftsClick: () => void,
  handleSubmittedClick: () => void,
  userDetails: { role: string[] }
): ButtonProps[] => [
    {
      type: "button",
      outlined: false,
      icon: "pi pi-filter-slash",
      label: "Clear",
      style: { marginRight: "2px", borderRadius: "3px", color: "#FFFFFF" },
      onClick: clearFilter,
      title: "Clear Filter",
      text: true,
      raised: true
    },

    ...(userDetails.role.includes("Admin") || userDetails.role.includes("Indents Write")
      ? [
        {
          label: "Add",
          icon: "pi pi-plus",
          severity: "success" as const,
          style: { marginRight: "2px", borderRadius: "3px" },
          onClick: handleAddClick,
          title: "Add New",
          outlined: false,
          text: true,
          raised: true
        }
      ]
      : []),

    {
      type: "button",
      label: "Columns",
      icon: "pi pi-list",
      style: { marginRight: "2px", borderRadius: "3px" },
      onClick: (event: React.MouseEvent<HTMLElement>) => openVisibilityPopover(event),
      title: "Select Columns",
      outlined: false,
      text: true,
      raised: true,
    },
    {
      type: "button",
      label: "Drafts",
      icon: "pi pi-pencil",
      style: { marginRight: "2px", borderRadius: "3px", backgroundColor: "#f0ad4e", color: "#fff" },
      onClick: handleDraftsClick,
      title: "View Draft Indents",
      text: true,
      raised: true,
    },
    {
      type: "button",
      label: "Submitted",
      icon: "pi pi-check-circle",
      style: { borderRadius: "3px", backgroundColor: "#5cb85c", color: "#fff" },
      onClick: handleSubmittedClick,
      title: "View Submitted Indents",
      text: true,
      raised: true,
    }
  ];


export const getTemplateExportData = (
  clearFilter: () => void,
  handleAddClick: () => void,
  openVisibilityPopover: (event: React.MouseEvent<HTMLElement>) => Promise<void>,
  userDetails: { role: string[] },
  exportCSV: (data: any) => void

): ButtonProps[] => {
  const allowedRoles = [
    "Admin",
    "New Inspection Write",
    "Inspection Mapping Write",
    "New Service Write",
    "Service Mapping Write",
    "Inspection Template Write",
    "Service Template Write",
    "Inspection Template Write",
  ];

  const hasWriteAccess = userDetails.role.some(role => allowedRoles.includes(role));

  const buttons: ButtonProps[] = [
    {
      type: "button",
      outlined: false,
      icon: "pi pi-filter-slash",
      label: "Clear",
      style: { marginRight: "2px", borderRadius: "3px", color: "#FFFFFF" },
      onClick: clearFilter,
      title: "Clear Filter",
      text: true,
      raised: true
    },
    ...(hasWriteAccess
      ? [
        {
          label: "Add",
          icon: "pi pi-plus",
          severity: "success" as const,
          style: { marginRight: "2px", borderRadius: "3px" },
          onClick: handleAddClick,
          title: "Add New Asset",
          outlined: false,
          text: true,
          raised: true
        }
      ]
      : []),
    {
      type: "button",
      label: "Columns",
      icon: "pi pi-list",
      style: { marginRight: "2px", borderRadius: "3px" },
      onClick: (event: React.MouseEvent<HTMLElement>) => openVisibilityPopover(event),
      title: "Select Columns",
      outlined: false,
      text: true,
      raised: true
    },
    {
      label: "Export",
      icon: "pi pi-upload",
      style: { marginLeft: "2px", borderRadius: "3px" },
      onClick: exportCSV,
      outlined: true,
      text: true,
      raised: true,
      title: "Export Excel",
    },
  ];

  return buttons;
};


export const getTemplateBButtonData = (
  clearFilter: () => void,
  handleAddClick: () => void,
  openVisibilityPopover: (event: React.MouseEvent<HTMLElement>) => Promise<void>,
  userDetails: { role: string[] }
): ButtonProps[] => {
  const allowedRoles = [
    "Admin",
    "New Inspection Write",
    "Inspection Mapping Write",
    "New Service Write",
    "Service Mapping Write",
    "Inspection Template Write",
    "Service Template Write",
    "Inspection Template Write",
  ];

  const hasWriteAccess = userDetails.role.some(role => allowedRoles.includes(role));

  const buttons: ButtonProps[] = [
    {
      type: "button",
      outlined: false,
      icon: "pi pi-filter-slash",
      label: "Clear",
      style: { marginRight: "2px", borderRadius: "3px", color: "#FFFFFF" },
      onClick: clearFilter,
      title: "Clear Filter",
      text: true,
      raised: true
    },
    ...(hasWriteAccess
      ? [
        {
          label: "Add",
          icon: "pi pi-plus",
          severity: "success" as const,
          style: { marginRight: "2px", borderRadius: "3px" },
          onClick: handleAddClick,
          title: "Add New Asset",
          outlined: false,
          text: true,
          raised: true
        }
      ]
      : []),
    {
      type: "button",
      label: "Columns",
      icon: "pi pi-list",
      style: { marginRight: "2px", borderRadius: "3px" },
      onClick: (event: React.MouseEvent<HTMLElement>) => openVisibilityPopover(event),
      title: "Select Columns",
      outlined: false,
      text: true,
      raised: true
    }
  ];

  return buttons;
};

export const getStockCodeButtonData = (
  clearFilter: () => void,
  overlayPanelRef: React.RefObject<any>,
  exportCSV: (selectionOnly?: boolean) => void, // ✅ Added
  selectedProducts: any[],
  handleAddStock: () => void,
  userDetails: { role: string[] }
): ButtonProps[] => {
  const allowedRoles = ["Admin", "Country View Write"];
  const hasWriteAccess = userDetails.role.some(role => allowedRoles.includes(role));

  const buttons: ButtonProps[] = [
    {
      type: "button",
      outlined: false,
      icon: "pi pi-filter-slash",
      label: "Clear",
      style: { marginRight: "2px", borderRadius: "3px", color: "#FFFFFF" },
      onClick: clearFilter,
      title: "Clear Filter",
      text: true,
      raised: true
    },
    ...(hasWriteAccess
      ? [
        {
          label: "Add",
          icon: "pi pi-plus",
          severity: "success" as const,
          style: { marginRight: "2px", borderRadius: "3px" },
          onClick: handleAddStock,
          title: "Add New Stock",
          outlined: false,
          text: true,
          raised: true
        }
      ]
      : []),
    {
      label: "Export",
      icon: "pi pi-upload",
      style: { marginLeft: "2px", borderRadius: "3px" },
      onClick: () => exportCSV(), // ✅ Call with default (undefined)
      outlined: true,
      text: true,
      raised: true,
      title: "Export Excel"
    }
  ];

  return buttons;
};





export const faultBodyTableIcon = (
  handleEditFault: (faultId: number) => void,
  handleDeleteFault: (faultId: number) => void,
  rowData: faultTypes
): ButtonProps[] => [
    {
      icon: "pi pi-pencil",
      rounded: true,
      outlined: true,
      className: "mr-2",
      onClick: () => handleEditFault(rowData.faultId),
      title: "Edit Asset",
    }
    ,
    {
      icon: "pi pi-trash",
      rounded: true,
      outlined: true,
      className: "mr-2",
      severity: 'danger',
      onClick: () => handleDeleteFault(rowData.faultId),
      title: "Delete Asset",
    }
  ]

export const getAssertColumns = (
  actionBodyTemplate: (rowData: assetType) => JSX.Element,
  actionPicTemplate: (rowData: assetType) => JSX.Element,
  actionCapexTemplate: (rowData: assetType) => JSX.Element,
  actionLogisticsTemplate: (rowData: assetType) => JSX.Element
): ColumnProps[] => [
    {
      selectionMode: "multiple",
      exportable: false,
    },
    {
      field: "imageAttachments.imageAttachmentId",
      header: "Asset Image",
      sortable: false,
      filter: false,
      body: actionPicTemplate,
    },

    // 1. Select an Owner
    {
      field: "assetOwnerName",
      header: "Asset Owner",
      sortable: true,
      filter: true,
      filterField: "assetOwnerName",
      filterPlaceholder: "Search",
    },

    {
      field: "classCode",
      header: "Class Code",
      sortable: true,
      filter: true,
      filterField: "classCode",
      filterPlaceholder: "Search",
    },

    // 2. Class Description
    {
      field: "classCodeDes",
      header: "Class Code Name",
      sortable: true,
      filter: true,
      filterField: "classCodeDes",
      filterPlaceholder: "Search",
    },



    // 4. Family / Type Description
    {
      field: "familyAssetName",
      header: "Family Asset",
      sortable: true,
      filter: true,
      filterField: "familyAssetName",
      filterPlaceholder: "Search",
    },



    // 6. Local Code
    {
      field: "localCode",
      header: "Local Code",
      sortable: true,
      filter: true,
      filterField: "localCode",
      filterPlaceholder: "Search",
    },

    // 7. Asset Name / Description
    {
      field: "assetName",
      header: "Asset Name",
      sortable: true,
      filter: true,
      filterField: "assetName",
      filterPlaceholder: "Search",
    },

    {
      field: "createdDate",
      header: "Created Date",
      sortable: true,
      filter: true,
      filterField: "createdDate",
      filterPlaceholder: "Search",
      body: (rowData) =>
        rowData.createdDate
          ? new Date(rowData.createdDate).toLocaleDateString()
          : "",
    },

    // 8. Harmony Code
    {
      field: "harmonyCode",
      header: "Harmony Code",
      sortable: true,
      filter: true,
      filterField: "harmonyCode",
      filterPlaceholder: "Search",
    },

    // 9. Harmony Name
    {
      field: "harmonyName",
      header: "Harmony Name",
      sortable: true,
      filter: true,
      filterField: "harmonyName",
      filterPlaceholder: "Search",
    },



    // 11. Global Code
    {
      field: "globalCode",
      header: "Global Code",
      sortable: true,
      filter: true,
      filterField: "globalCode",
      filterPlaceholder: "Search",
    },

    // 12. Project → Assuming `intext`
    {
      field: "intext",
      header: "Intext",
      sortable: true,
      filter: true,
      filterField: "intext",
      filterPlaceholder: "Search",
    },

    // 13. Country → Assuming COO

    {
      field: "countryName",
      header: "Current Location",
      sortable: true,
      filter: true,
      filterField: "countryName",
      filterPlaceholder: "Search",
      //style: { minWidth: '12rem' }
    },


    // 14. Tool / Equipment
    {
      field: "toolequip",
      header: "Tool Equip",
      sortable: true,
      filter: true,
      filterField: "toolequip",
      filterPlaceholder: "Search",
    },

    // 15. Internal / External → Assuming techAdditional
    {
      field: "techAdditional",
      header: "Tech Additional",
      sortable: true,
      filter: true,
      filterField: "techAdditional",
      filterPlaceholder: "Search",
    },

    // 16. Type of Contract
    {
      field: "contractType",
      header: "Contract Type",
      sortable: true,
      filter: true,
      filterField: "contractType",
      filterPlaceholder: "Search",
    },

    // 17. Techniques
    {
      field: "techniqueNames",
      header: "Technique",
      sortable: true,
      filter: true,
      filterField: "techniqueNames",
      filterPlaceholder: "Search",
      body: (rowData) => {
        const techniqueNames = Array.isArray(rowData.techniqueNames)
          ? rowData.techniqueNames
          : rowData.techniqueNames
            ? [rowData.techniqueNames]
            : [];
        return techniqueNames.length ? techniqueNames.join(", ") : "";
      },
    },

    // 18. Attach File → Assuming all attachments


    // 19. Comments
    {
      field: "comments",
      header: "Comments",
      sortable: true,
      filter: true,
      filterField: "comments",
      filterPlaceholder: "Search",
    },

    // 20. Manufacturer
    {
      field: "manufacturerName",
      header: "Manufacturer",
      sortable: true,
      filter: true,
      filterField: "manufacturerName",
      filterPlaceholder: "Search",
    },

    {
      field: "modelName",
      header: "Model",
      sortable: true,
      filter: true,
      filterField: "modelName",
      filterPlaceholder: "Search",
    },

    // 21. Model → Not provided, can be added if exists

    // 22. Serial Number
    {
      field: "srNo",
      header: "Sr No",
      sortable: true,
      filter: true,
      filterField: "srNo",
      filterPlaceholder: "Search",
    },

    // 23. Manufacturer Date
    {
      field: "manufacturerDate",
      header: "Manufacturing Date",
      sortable: true,
      filter: true,
      filterField: "manufacturerDate",
      filterPlaceholder: "Search",
      body: (rowData) => formatDate(rowData.manufacturerDate),
    },

    // 24–31. Optionals
    ...[1, 2, 3, 4, 5, 6, 7, 8].map(i => ({
      field: `optional${i}`,
      header: `Optional ${i}`,
      sortable: true,
      filter: true,
      filterField: `optional${i}`,
      filterPlaceholder: "Search",
    })),

    // 32. Purchase Date
    {
      field: "purchaseDate",
      header: "Purchase Date",
      sortable: true,
      filter: true,
      filterField: "purchaseDate",
      filterPlaceholder: "Search",
      body: (rowData) => formatDate(rowData.purchaseDate),
    },

    // 33. Purchase Value
    {
      field: "purchaseValue",
      header: "Purchase Value",
      sortable: true,
      filter: true,
      filterField: "purchaseValue",
      filterPlaceholder: "Search",
    },

    // 34. Insurance Value
    {
      field: "insuranceValue",
      header: "Insurance Value",
      sortable: true,
      filter: true,
      filterField: "insuranceValue",
      filterPlaceholder: "Search",
    },

    // 35. Insurance Company → Not provided, could be added if exists

    // 36. Capex Ref
    {
      field: "capexFormRef",
      header: "Capex Form Ref",
      sortable: true,
      filter: true,
      filterField: "capexFormRef",
      filterPlaceholder: "Search",
    },

    // 37. Capex Attachment already added
    {
      field: "capexAttachmentId",
      header: "Capex Attachment",
      sortable: false,
      filter: false,
      body: actionCapexTemplate,
    },



    // 38. Single Shift
    {
      field: "singleShift",
      header: "Single Shift",
      sortable: true,
      filter: true,
      filterField: "singleShift",
      filterPlaceholder: "Search",
    },

    // 39. Double Shift
    {
      field: "doubleShift",
      header: "Double Shift",
      sortable: true,
      filter: true,
      filterField: "doubleShift",
      filterPlaceholder: "Search",
    },

    // 40. Currency
    {
      field: "insuranceCurrency",
      header: "Insurance Currency",
      sortable: true,
      filter: true,
      filterField: "insuranceCurrency",
      filterPlaceholder: "Search",
      style: { minWidth: '12rem' },
    },

    // 41. COO → Already included

    {
      field: "coo",
      header: "COO",
      sortable: true,
      filter: true,
      filterField: "coo",
      filterPlaceholder: "Search",
    },

    // 42. Length
    {
      field: "length",
      header: "Length",
      sortable: true,
      filter: true,
      filterField: "length",
      filterPlaceholder: "Search",
    },

    // 43. Width / Dia 

    {
      field: "width",
      header: "Width",
      sortable: true,
      filter: true,
      filterField: "width",
      filterPlaceholder: "Search",
    },

    // 44. Height
    {
      field: "height",
      header: "Height",
      sortable: true,
      filter: true,
      filterField: "height",
      filterPlaceholder: "Search",
    },

    // 45. Weight
    {
      field: "weight",
      header: "Weight",
      sortable: true,
      filter: true,
      filterField: "weight",
      filterPlaceholder: "Search",
    },

    // 46. HS Code
    {
      field: "hsCode",
      header: "HS Code",
      sortable: true,
      filter: true,
      filterField: "hsCode",
      filterPlaceholder: "Search",
    },

    // 47. Attach Logistics File 

    {
      field: "logisticsAttachmentId",
      header: "Logistics Attachment",
      sortable: false,
      filter: false,
      body: actionLogisticsTemplate,
    },

    // Final action buttons
    {
      body: actionBodyTemplate,
      exportable: false,
    }
  ];


// export const getAssertColumns = (
//   actionBodyTemplate: (rowData: assetType) => JSX.Element,
//   actionPicTemplate: (rowData: assetType) => JSX.Element,
//   actionCapexTemplate: (rowData: assetType) => JSX.Element,
//   actionLogisticsTemplate: (rowData: assetType) => JSX.Element
// ):ColumnProps[] => [
//     {
//         selectionMode: "multiple",
//         exportable: false
//     },
//     {
//         field: "assetOwnerName",
//         header: "Asset Owner",
//         sortable: true,
//         filter: true,
//         filterField: "assetOwnerName",
//         filterPlaceholder: "Search",
//         //style: { minWidth: '12rem' }
//     },
//     {
//         field: "harmonyCode",
//         header: "Harmony Code",
//         sortable: true,
//         filter: true,
//         filterField: "harmonyCode",
//         filterPlaceholder: "Search",
//         //style: { minWidth: '12rem' }
//     },
//     {
//         field: "codeType",
//         header: "Code Type",
//         sortable: true,
//         filter: true,
//         filterField:"codeType",
//         filterPlaceholder: "Search",
//         //style: { minWidth: '12rem' }
//     },
//     {
//         field: "familyAssetName",
//         header: "Family Asset",
//         sortable: true,
//         filter: true,
//         filterField: 'familyAssetName',
//         filterPlaceholder: "Search",
//         //style: { minWidth: '12rem' }
//     },
//     {
//         field: "assetName",
//         header: "Asset Name",
//         sortable: true,
//         filter: true,
//         filterField:"assetName",
//         filterPlaceholder: "Search",
//         //style: { minWidth: '12rem' }
//     },
//     {
//       field: "imageAttachments.imageAttachmentId",
//       header: "Asset Image",
//       sortable: false,
//       filter: false, // Set to true if you want filtering
//       filterField: "imageAttachments.imageAttachmentId", // Correct filter field
//       filterPlaceholder: "Search",
//       body: actionPicTemplate,
//   }, 

//   {
//   field: "capexAttachmentId",
//   header: "Capex Attachment",
//   sortable: false,
//   filter: false,
//   filterField: "capexAttachmentId",
//   filterPlaceholder: "Search",
//   body: actionCapexTemplate,
// },
// {
//   field: "logisticsAttachmentId",
//   header: "Logistics Attachment",
//   sortable: false,
//   filter: false,
//   filterField: "logisticsAttachmentId",
//   filterPlaceholder: "Search",
//   body: actionLogisticsTemplate,
// },

//     {
//         field: "harmonyName",
//         header: "Harmony Name",
//         sortable: true,
//         filter: true,
//         filterField:"harmonyName",
//         filterPlaceholder: "Search",
//         //style: { minWidth: '12rem' }
//     },
//     {
//     field: "localCode",
//     header: "Local Code",
//     sortable: true,
//     filter: true,
//     filterField: "localCode",
//     filterPlaceholder: "Search",
// },

// {
//     field: "contractType",
//     header: "Contract Type",
//     sortable: true,
//     filter: true,
//     filterField: "contractType",
//     filterPlaceholder: "Search",
// },
// {
//     field: "purchaseValue",
//     header: "Purchase Value",
//     sortable: true,
//     filter: true,
//     filterField: "purchaseValue",
//     filterPlaceholder: "Search",
// },
// {
//     field: "toolequip",
//     header: "Tool Equip",
//     sortable: true,
//     filter: true,
//     filterField: "toolequip",
//     filterPlaceholder: "Search",
// },
// {
//     field: "globalCode",
//     header: "Global Code",
//     sortable: true,
//     filter: true,
//     filterField: "globalCode",
//     filterPlaceholder: "Search",
// },
// {
//     field: "intext",
//     header: "Intext",
//     sortable: true,
//     filter: true,
//     filterField: "intext",
//     filterPlaceholder: "Search",
// },
// {
//     field: "classCodeDes",
//     header: "Class Description",
//     sortable: true,
//     filter: true,
//     filterField: "classCodeDes",
//     filterPlaceholder: "Search",
// },
// {
//     field: "typeCodeDes",
//     header: "Type Description",
//     sortable: true,
//     filter: true,
//     filterField: "typeCodeDes",
//     filterPlaceholder: "Search",
// },
//     {
//         field: "srNo",
//         header: "Sr No",
//         sortable: true,
//         filter: true,
//         filterField:'srNo',
//         filterPlaceholder: "Search",
//         //style: { minWidth: '12rem' }
//     },
//     // {
//     //     field: "techniqueName",
//     //     header: "Technique",
//     //     sortable: true,
//     //     filter: true,
//     //     filterField:'techniqueNames',
//     //     filterPlaceholder: "Search",
//     //     //style: { minWidth: '12rem' }
//     // },
//    {
//     field: "techniqueNames",
//     header: "Technique",
//     sortable: true,
//     filter: true,
//     filterField: "techniqueNames",
//     filterPlaceholder: "Search",
//     body: (rowData) => {
//         const techniqueNames = Array.isArray(rowData.techniqueNames)
//             ? rowData.techniqueNames
//             : rowData.techniqueNames ? [rowData.techniqueNames] : []; // Fallback to an empty array
//         return techniqueNames.length ? techniqueNames.join(", ") : "";  // Join or display ""
//     }
// },


//     {
//         field: "techAdditional",
//         header: "Tech Additional",
//         sortable: true,
//         filter: true,
//         filterField:"techAdditional",
//         filterPlaceholder: "Search",
//         //style: { minWidth: '12rem' }
//     },
//     {
//         field: "currentLocation",
//         header: "Current Location",
//         sortable: true,
//         filter: true,
//         filterField:"currentLocation",
//         filterPlaceholder: "Search",
//         //style: { minWidth: '12rem' }
//     },
//     {
//         field: "manufacturerName",
//         header: "Manufacturer",
//         sortable: true,
//         filter: true,
//         filterField:"manufacturerName",
//         filterPlaceholder: "Search",
//         //style: { minWidth: '12rem' }
//     },
//     {
//         field: "manufacturerDate",
//         header: "Manufacturing Date",
//         sortable: true,
//         filter: true,
//         filterField:"manufacturerDate",
//         filterPlaceholder: "Search",
//         //style: { minWidth: '12rem' },
//         body: (rowData) => formatDate(rowData.manufacturerDate)
//     },
//     {
//         field: "purchaseDate",
//         header: "Purchase Date",
//         sortable: true,
//         filter: true,
//         filterField:'purchaseDate',
//         filterPlaceholder: "Search",
//         //style: { minWidth: '12rem' },
//         body: (rowData) => formatDate(rowData.purchaseDate)
//     },
//     {
//         field: "insuranceValue",
//         header: "Insurance Value",
//         sortable: true,
//         filter: true,
//         filterField:"insuranceValue",
//         filterPlaceholder: "Search",
//         //style: { minWidth: '12rem' }
//     },
//     {
//         field: "insuranceCurrency",
//         header: "Insurance Currency",
//         sortable: true,
//         filter: true,
//         filterField:"insuranceCurrency",
//         filterPlaceholder: "Search",
//         style: { minWidth: '12rem' }
//     },
//     {
//         field: "capexFormRef",
//         header: "Capex Form Ref",
//         sortable: true,
//         filter: true,
//         filterField:"capexFormRef",
//         filterPlaceholder: "Search",
//         //style: { minWidth: '12rem' }
//     },
//     {
//         field: "singleShift",
//         header: "Single Shift",
//         sortable: true,
//         filter: true,
//         filterField:"singleShift",
//         filterPlaceholder: "Search",
//         //style: { minWidth: '12rem' }
//     },
//     {
//         field: "doubleShift",
//         header: "Double Shift",
//         sortable: true,
//         filter: true,
//         filterField:"doubleShift",
//         filterPlaceholder: "Search",
//         //style: { minWidth: '12rem' }
//     },
//     {
//         field: "coo",
//         header: "COO",
//         sortable: true,
//         filter: true,
//         filterField:"coo",
//         filterPlaceholder: "Search",
//         //style: { minWidth: '12rem' }
//     },
//     {
//         field: "comments",
//         header: "Comments",
//         sortable: true,
//         filter: true,
//         filterField:"comments",
//         filterPlaceholder: "Search",
//         //style: { minWidth: '12rem' }
//     },
//     {
//         field: "length",
//         header: "Length",
//         sortable: true,
//         filter: true,
//         filterField:'length',
//         filterPlaceholder: "Search",
//         //style: { minWidth: '12rem' }
//     },
//     {
//         field: "height",
//         header: "Height",
//         sortable: true,
//         filter: true,
//         filterField:"height",
//         filterPlaceholder: "Search",
//         //style: { minWidth: '12rem' }
//     },
//     {
//         field: "weight",
//         header: "Weight",
//         sortable: true,
//         filter: true,
//         filterField:"weight",
//         filterPlaceholder: "Search",
//         //style: { minWidth: '12rem' }
//     },
//     {
//         field: "hsCode",
//         header: "HS Code",
//         sortable: true,
//         filter: true,
//         filterField:"hsCode",
//         filterPlaceholder: "Search",
//         //style: { minWidth: '12rem' }
//     },
//     {
//       field: "optional1",
//       header: "Optional 1",
//       sortable: true,
//       filter: true,
//       filterField: "optional1",
//       filterPlaceholder: "Search",
//     },
//   {
//       field: "optional2",
//       header: "Optional 2",
//       sortable: true,
//       filter: true,
//       filterField: "optional2",
//       filterPlaceholder: "Search",
//   },
//   {
//       field: "optional3",
//       header: "Optional 3",
//       sortable: true,
//       filter: true,
//       filterField: "optional3",
//       filterPlaceholder: "Search",
//   },
//   {
//       field: "optional4",
//       header: "Optional 4",
//       sortable: true,
//       filter: true,
//       filterField: "optional4",
//       filterPlaceholder: "Search",
//   },
//   {
//       field: "optional5",
//       header: "Optional 5",
//       sortable: true,
//       filter: true,
//       filterField: "optional5",
//       filterPlaceholder: "Search",
//   },
//   {
//       field: "optional6",
//       header: "Optional 6",
//       sortable: true,
//       filter: true,
//       filterField: "optional6",
//       filterPlaceholder: "Search",
//   },
//   {
//       field: "optional7",
//       header: "Optional 7",
//       sortable: true,
//       filter: true,
//       filterField: "optional7",
//       filterPlaceholder: "Search",
//   },
//   {
//       field: "optional8",
//       header: "Optional 8",
//       sortable: true,
//       filter: true,
//       filterField: "optional8",
//       filterPlaceholder: "Search",
//   },

//     {
//         body: actionBodyTemplate,
//         exportable: false,
//         //style: { minWidth: '12rem' }
//     }
// ];

export const getIndentsColumns = (
  actionBodyTemplate: (rowData: any) => JSX.Element
): ColumnProps[] => [
    {
      field: "indentId",
      header: "Id",
      sortable: true,
      filter: true,
      filterField: "indentId",
      filterPlaceholder: "Search",
      style: { minWidth: '12rem' }
    },
    {
      field: "username",
      header: "User",
      sortable: true,
      filter: true,
      filterField: "username",
      filterPlaceholder: "Search",
      style: { minWidth: '12rem' },
    },
    {
      field: "requestFrom",
      header: "Resuest From",
      sortable: true,
      filter: true,
      filterField: "requestFrom",
      filterPlaceholder: "Search",
      style: { minWidth: '12rem' },
    },
    {
      field: "requestTo",
      header: "Resuest To",
      sortable: true,
      filter: true,
      filterField: "requestTo",
      filterPlaceholder: "Search",
      style: { minWidth: '12rem' },
    },
    {
      field: "createdDate",
      header: "Created Date",
      sortable: true,
      filter: true,
      filterField: "createdDate",
      body: (rowData: any) =>
        rowData.createdDate
          ? new Date(rowData.createdDate).toLocaleDateString()
          : "-",
      style: { minWidth: "14rem" },
    },
    {
      field: "lastEditedDate",
      header: "Last Edited Date",
      sortable: true,
      filter: true,
      filterField: "lastEditedDate",
      body: (rowData: any) =>
        rowData.lastEditedDate
          ? new Date(rowData.lastEditedDate).toLocaleDateString()
          : "-",
      style: { minWidth: "14rem" },
    },
    {
      body: actionBodyTemplate,
      exportable: false,
      //style: { minWidth: '12rem' }
    }
  ];

export const getIndentsTemplateColumns = (
  actionBodyTemplate: (rowData: IndentFormData) => JSX.Element
): ColumnProps[] => [
    {
      field: "indentTemplateId",
      header: "Id",
      sortable: true,
      filter: true,
      filterField: "indentTemplateId",
      filterPlaceholder: "Search",
      style: { minWidth: '12rem' }
    },
    {
      field: "indentTemplateName",
      header: "Indent Template",
      sortable: true,
      filter: true,
      filterField: "indentTemplateName",
      filterPlaceholder: "Search",
      style: { minWidth: '12rem' },
    },

    {
      body: actionBodyTemplate,
      exportable: false,
      //style: { minWidth: '12rem' }
    }
  ];


export const getServiceTemplateColumns = (
  actionBodyTemplate: (rowData: ServiceTemplateMaster) => JSX.Element
): ColumnProps[] => [

    {
      field: "serviceTemplateId",
      header: "Id",
      sortable: true,
      filter: false,
      filterField: "serviceTemplateId",
      filterPlaceholder: "Search",
      //style: { minWidth: '12rem' }
    },

    {
      field: "serviceTemplateName",
      header: "Service Template Name",
      sortable: true,
      filter: false,
      filterField: "serviceTemplateName",
      filterPlaceholder: "Search",
      //style: { minWidth: '12rem' }
    },

    {
      field: "familyName",
      header: "Asset Type",
      sortable: true,
      filter: false,
      filterField: "familyName",
      filterPlaceholder: "Search",
      //style: { minWidth: '12rem' }
    },


    {
      body: actionBodyTemplate,
      exportable: false,
      //style: { minWidth: '12rem' }
    }
  ];

export const savedServiceColumns = (
  actionBodyTemplate: (rowData: ServiceReportPayload) => JSX.Element
): ColumnProps[] => [
    {
      selectionMode: "multiple",
      exportable: false,
    },
    {
      field: "serviceReportingId",
      header: "Id",
      sortable: true,
    },
    {
      field: "familyName",
      header: "Asset Type",
      sortable: true,
    },
    {
      field: "assetName",
      header: "Asset Name",
      sortable: true,
    },
    {
      field: "name",
      header: "User Name",
      sortable: true,
    },
    {
      field: "date",
      header: "Service Date",
      sortable: true,
      body: (rowData) =>
        rowData.date ? new Date(rowData.date).toLocaleDateString() : "",
    },
    {
      field: "serviceName",
      header: "Service Type",
      sortable: true,
    },
    {
      field: "serviceTemplateName",
      header: "Service Template",
      sortable: true,
    },
    {
      field: "projectName",
      header: "Project",
      sortable: true,
    },
    {
      field: "regionName",
      header: "Region",
      sortable: true,
    },
    {
      field: "countryName",
      header: "Country",
      sortable: true,
    },
    {
      field: "engineHours",
      header: "Engine Hours",
      sortable: true,
    },
    {
      field: "commonComments",
      header: "Comments",
      sortable: false,
      style: { minWidth: "20rem", whiteSpace: "normal" }, // allow wrapping
    },
    {
      body: actionBodyTemplate,
      exportable: false,
    },
  ];

export const savedInspectionColumns = (
  actionBodyTemplate: (rowData: InspectionReportPayload) => JSX.Element
): ColumnProps[] => [
    {
      selectionMode: "multiple",
      exportable: false,
    },

    {
      field: "inspectionReportingId",
      header: "Id",
      sortable: true,
      filter: false,
      filterField: "inspectionReportingId",
      filterPlaceholder: "Search",
      //style: { minWidth: '12rem' }
    },
    {
      field: "familyName",
      header: "Asset Type",
      sortable: true,
    },
    {
      field: "assetName",
      header: "Asset Name",
      sortable: true,
    },
    {
      field: "name",
      header: "User Name",
      sortable: true,
    },
    {
      field: "date",
      header: "Service Date",
      sortable: true,
      body: (rowData) =>
        rowData.date ? new Date(rowData.date).toLocaleDateString() : "",
    },
    {
      field: "serviceName",
      header: "Inspection Type",
      sortable: true,
    },
    {
      field: "inspectionTemplateName",
      header: "Inspection Template",
      sortable: true,
    },
    {
      field: "projectName",
      header: "Project",
      sortable: true,
    },
    {
      field: "regionName",
      header: "Region",
      sortable: true,
    },
    {
      field: "countryName",
      header: "Country",
      sortable: true,
    },
    {
      field: "engineHours",
      header: "Engine Hours",
      sortable: true,
    },
    {
      field: "commonComments",
      header: "Comments",
      sortable: false,
      style: { minWidth: "20rem", whiteSpace: "normal" }, // allow wrapping
    },
    {
      body: actionBodyTemplate,
      exportable: false,
    },
  ];


export const getInspectionAssetMapTemplateColumns = (
  actionBodyTemplate: (rowData: InspectionAssetMapMaster) => JSX.Element
): ColumnProps[] => [

    {
      field: "inspectionAssetMapId",
      header: "Id",
      sortable: true,
      filter: false,
      filterField: "inspectionAssetMapId",
      filterPlaceholder: "Search",
      //style: { minWidth: '12rem' }
    },

    {
      field: "inspectionTemplateName",
      header: " Template Name",
      sortable: true,
      filter: false,
      filterField: "inspectionTemplateName",
      filterPlaceholder: "Search",
      //style: { minWidth: '12rem' }
    },

    {
      field: "familyName",
      header: "Asset Type",
      sortable: true,
      filter: false,
      filterField: "familyName",
      filterPlaceholder: "Search",
      //style: { minWidth: '12rem' }
    },
    {
      field: "assetName",
      header: "Asset Name",
      sortable: true,
      filter: false,
      filterField: "assetName",
      filterPlaceholder: "Search",
      //style: { minWidth: '12rem' }
    },


    {
      body: actionBodyTemplate,
      exportable: false,
      //style: { minWidth: '12rem' }
    }
  ];

export const getServiceAssetMapTemplateColumns = (
  actionBodyTemplate: (rowData: FaultAssetMapMaster) => JSX.Element
): ColumnProps[] => [

    {
      field: "serviceAssetMapId",
      header: "Id",
      sortable: true,
      filter: false,
      filterField: "serviceAssetMapId",
      filterPlaceholder: "Search",
      //style: { minWidth: '12rem' }
    },

    {
      field: "serviceTemplateName",
      header: "Service Template Name",
      sortable: true,
      filter: false,
      filterField: "serviceTemplateName",
      filterPlaceholder: "Search",
      //style: { minWidth: '12rem' }
    },

    {
      field: "familyName",
      header: "Asset Type",
      sortable: true,
      filter: false,
      filterField: "familyName",
      filterPlaceholder: "Search",
      //style: { minWidth: '12rem' }
    },
    {
      field: "assetName",
      header: "Asset Name",
      sortable: true,
      filter: false,
      filterField: "assetName",
      filterPlaceholder: "Search",
      //style: { minWidth: '12rem' }
    },


    {
      body: actionBodyTemplate,
      exportable: false,
      //style: { minWidth: '12rem' }
    }
  ];

export const getInspectionTemplateColumns = (
  actionBodyTemplate: (rowData: InspectionTemplateMaster) => JSX.Element
): ColumnProps[] => [

    {
      field: "inspectionTemplateId",
      header: "Id",
      sortable: true,
      filter: false,
      filterField: "inspectionTemplateId",
      filterPlaceholder: "Search",
      //style: { minWidth: '12rem' }
    },

    {
      field: "inspectionTemplateName",
      header: "Inspection Template Name",
      sortable: true,
      filter: false,
      filterField: "inspectionTemplateName",
      filterPlaceholder: "Search",
      //style: { minWidth: '12rem' }
    },

    {
      field: "familyName",
      header: "Asset Type",
      sortable: true,
      filter: false,
      filterField: "familyName",
      filterPlaceholder: "Search",
      //style: { minWidth: '12rem' }
    },


    {
      body: actionBodyTemplate,
      exportable: false,
      //style: { minWidth: '12rem' }
    }
  ];

export const getFamilyAssetColumns = (): ColumnProps[] => [
  {
    field: "familyAssetId",
    header: "Id",
    sortable: true,
    filter: true,
    filterField: "familyAssetId",
    filterPlaceholder: "Search",
    style: { minWidth: '12rem' }
  },
  {
    field: "familyName",
    header: "Family Name",
    sortable: true,
    filter: true,
    filterField: "familyName",
    filterPlaceholder: "Search",
    style: { minWidth: '12rem' },
  },
];

export const getOwnerAssetColumns = (): ColumnProps[] => [
  {
    field: "assetOwnerId",
    header: "Id",
    sortable: true,
    filter: true,
    filterField: "assetOwnerId",
    filterPlaceholder: "Search",
    style: { minWidth: '12rem' },
    filterMatchMode: "contains" // Use "startsWith", "equals", etc., if needed
  },
  {
    field: "assetOwnerName",
    header: "Owner Name",
    sortable: true,
    filter: true,
    filterField: "assetOwnerName",
    filterPlaceholder: "Search",
    style: { minWidth: '12rem' },
  },
];

export const getTransportColumns = (): ColumnProps[] => [
  {
    field: "transportId",
    header: "Id",
    sortable: true,
    filter: true,
    filterField: "transportId",
    filterPlaceholder: "Search",
    style: { minWidth: '12rem' }
  },
  {
    field: "transportName",
    header: "Transport Name",
    sortable: true,
    filter: true,
    filterField: "transportName",
    filterPlaceholder: "Search",
    style: { minWidth: '12rem' },
  },
];

export const getTechniqueAssetColumns = (): ColumnProps[] => [
  {
    field: "techniqueId",
    header: "Id",
    sortable: true,
    filter: true,
    filterField: "techniqueId",
    filterPlaceholder: "Search",
    style: { minWidth: '12rem' }
  },
  {
    field: "techniqueName",
    header: "Technique Name",
    sortable: true,
    filter: true,
    filterField: "techniqueName",
    filterPlaceholder: "Search",
    style: { minWidth: '12rem' },
  },
];

export const getStatusColumns = (): ColumnProps[] => [
  {
    field: "statusId",
    header: "Id",
    sortable: true,
    filter: true,
    filterField: "statusId",
    filterPlaceholder: "Search",
    style: { minWidth: '12rem' }
  },
  {
    field: "statusInfo",
    header: "Status Info",
    sortable: true,
    filter: true,
    filterField: "statusInfo",
    filterPlaceholder: "Search",
    style: { minWidth: '12rem' },
  },
];


export const getRegionColumns = (): ColumnProps[] => [
  {
    field: "regionId",
    header: "Id",
    sortable: true,
    filter: true,
    filterField: "regionId",
    filterPlaceholder: "Search",
    style: { minWidth: '12rem' }
  },
  {
    field: "regionName",
    header: "Region Name",
    sortable: true,
    filter: true,
    filterField: "regionName",
    filterPlaceholder: "Search",
    style: { minWidth: '12rem' },
  },
];
export const getCountryAssetColumns = (): ColumnProps[] => [
  {
    field: "currentLocationId",
    header: "Id",
    sortable: true,
    filter: true,
    filterField: "currentLocationId",
    filterPlaceholder: "Search",
    style: { minWidth: '12rem' }
  },
  {
    field: "countryName",
    header: "Country",
    sortable: true,
    filter: true,
    filterField: "countryName",
    filterPlaceholder: "Search",
    style: { minWidth: '12rem' },
  },
];

export const getProjectColumns = (): ColumnProps[] => [
  {
    field: "projectId",
    header: "Id",
    sortable: true,
    filter: true,
    filterField: "projectId",
    filterPlaceholder: "Search",
    style: { minWidth: '12rem' }
  },
  {
    field: "projectName",
    header: "Project",
    sortable: true,
    filter: true,
    filterField: "projectName",
    filterPlaceholder: "Search",
    style: { minWidth: '12rem' },
  },
];


export const getCurrencyAssetColumns = (): ColumnProps[] => [
  {
    field: "insuranceCurrencyId",
    header: "ID",
    sortable: true,
    filter: true,
    filterField: "insuranceCurrencyId",
    filterPlaceholder: "Search",
    style: { minWidth: '12rem' }
  },
  {
    field: "insuranceCurrency",
    header: "Currency",
    sortable: true,
    filter: true,
    filterField: "insuranceCurrency",
    filterPlaceholder: "Search",
    style: { minWidth: '12rem' },
  },
  {
    field: "unitValue",
    header: "Unit Value",
    sortable: true,
    filter: true,
    filterField: "unitValue",
    filterPlaceholder: "Search",
    style: { minWidth: '12rem' },
  },
];

export const getBackChargeColumns = (): ColumnProps[] => [
  {
    field: "backChargeId",
    header: "ID",
    sortable: true,
    filter: true,
    filterField: "backChargeId",
    filterPlaceholder: "Search",
    style: { minWidth: "8rem" },
  },
  {
    field: "backChargeName",
    header: "Backcharge Name",
    sortable: true,
    filter: true,
    filterField: "backChargeName",
    filterPlaceholder: "Search",
    style: { minWidth: "14rem" },
  },
  {
    field: "fromhours",
    header: "From Hours",
    sortable: true,
    filter: true,
    filterField: "fromhours",
    filterPlaceholder: "Search",
    style: { minWidth: "10rem" },
  },
  {
    field: "tohours",
    header: "To Hours",
    sortable: true,
    filter: true,
    filterField: "tohours",
    filterPlaceholder: "Search",
    style: { minWidth: "10rem" },
  },
];

export const getCategoryAssetColumns = (): ColumnProps[] => [
  {
    field: "categoryId",
    header: "ID",
    sortable: true,
    filter: true,
    filterField: "categoryId",
    filterPlaceholder: "Search",
    style: { minWidth: '12rem' }
  },
  {
    field: "categoryName",
    header: "Category",
    sortable: true,
    filter: true,
    filterField: "categoryName",
    filterPlaceholder: "Search",
    style: { minWidth: '12rem' },
  },

];


export const getManufacturerAssetColumns = (): ColumnProps[] => [
  {
    field: "manufacturerId",
    header: "Id",
    sortable: true,
    filter: true,
    filterField: "manufacturerId",
    filterPlaceholder: "Search",
    style: { minWidth: '12rem' }
  },
  {
    field: "manufacturerName",
    header: "Manufacturer",
    sortable: true,
    filter: true,
    filterField: "manufacturerName",
    filterPlaceholder: "Search",
    style: { minWidth: '12rem' },
  },
];

export const getSearchAndExportData = (
  globalFilterValue: string,
  onGlobalFilterChange: (e: React.ChangeEvent<HTMLInputElement>) => void,
  exportCSV: (data: any) => void
) => ({
  inputField: {
    iconPosition: "left",
    placeholder: "Search",
    value: globalFilterValue,
    onChange: onGlobalFilterChange,
  },
  headerButtons: [
    {
      label: "Export",
      icon: "pi pi-upload",
      style: { marginLeft: "2px", borderRadius: "3px" },
      onClick: exportCSV,
      outlined: true,
      text: true,
      raised: true,
      title: "Export Excel",
    },
  ],
});

export const getAssetSearchAndExportData = (
  globalFilterValue: string,
  onGlobalFilterChange: (e: React.ChangeEvent<HTMLInputElement>) => void,
  exportCSV: (data: any) => void
) => ({
  inputField: {
    iconPosition: "left",
    placeholder: "Search",
    value: globalFilterValue,
    onChange: onGlobalFilterChange,
  },
  headerButtons: [
    {
      label: "Export",
      icon: "pi pi-upload",
      style: { marginLeft: "2px", borderRadius: "3px" },
      onClick: exportCSV,
      outlined: true,
      text: true,
      raised: true,
      title: "Export Excel",
    },
  ],
});

export const getStockSearchAndExportData = (
  globalFilterValue: string,
  onGlobalFilterChange: (e: React.ChangeEvent<HTMLInputElement>) => void,
  exportCSV: (data: any) => void
) => ({
  inputField: {
    iconPosition: "left",
    placeholder: "Search",
    value: globalFilterValue,
    onChange: onGlobalFilterChange,
  },
  headerButtons: [
    {
      label: "Export",
      icon: "pi pi-upload",
      style: { marginLeft: "2px", borderRadius: "3px" },
      onClick: exportCSV,
      outlined: true,
      text: true,
      raised: true,
      title: "Export Excel",
    },
  ],
});

export const getServiceSearchAndExportData = (
  globalFilterValue: string,
  onGlobalFilterChange: (e: React.ChangeEvent<HTMLInputElement>) => void,

) => ({
  inputField: {
    iconPosition: "left",
    placeholder: "Search",
    value: globalFilterValue,
    onChange: onGlobalFilterChange,
  }

});


export const getUsersColumns = (): ColumnProps[] => [
  {
    field: "user_id",
    header: "Id",
    sortable: true,
    filter: true,
    filterField: "user_id",
    filterPlaceholder: "Search",
    style: { minWidth: '12rem' }
  },
  {
    field: "name",
    header: "User Name",
    sortable: true,
    filter: true,
    filterField: "name",
    filterPlaceholder: "Search",
    style: { minWidth: '12rem' },
  },
];


export const getStockCodeColumns = (): ColumnProps[] => [
  {
    field: "stockCodeId",
    header: "Stock Code ID",
    sortable: true,
    filter: true,
    filterField: "stockCodeId",
    filterPlaceholder: "Search",
    style: { minWidth: '12rem' }
  },
  {
    field: "stockCode",
    header: "Stock Code",
    sortable: true,
    filter: true,
    filterField: "stockCode",
    filterPlaceholder: "Search",
    style: { minWidth: '12rem' },
  },

  {
    field: "description",
    header: "Description",
    sortable: true,
    filter: true,
    filterField: "description",
    filterPlaceholder: "Search",
    style: { minWidth: '12rem' },
  },
  {
    field: "currentStock",
    header: "Current Stock",
    sortable: true,
    filter: true,
    filterField: "currentStock",
    filterPlaceholder: "Search",
    style: { minWidth: '12rem' },
  },
];


export const getCodeTypeColumns = (): ColumnProps[] => [
  {
    field: "typeCodeId",
    header: "Code ID",
    sortable: true,
    filter: true,
    filterField: "typeCodeId",
    filterPlaceholder: "Search",
    style: { minWidth: '12rem' }
  },
  {
    field: "typeCode",
    header: "Code Type",
    sortable: true,
    filter: true,
    filterField: "typeCode",
    filterPlaceholder: "Search",
    style: { minWidth: '12rem' },
  },

  {
    field: "typeCodeDes",
    header: "Description",
    sortable: true,
    filter: true,
    filterField: "typeCodeDes",
    filterPlaceholder: "Search",
    style: { minWidth: '12rem' },
  },

];

export const getClassCodeColumns = (): ColumnProps[] => [
  {
    field: "classCodeId",
    header: "Code ID",
    sortable: true,
    filter: true,
    filterField: "classCodeId",
    filterPlaceholder: "Search",
    style: { minWidth: '12rem' }
  },
  {
    field: "classCode",
    header: "Code Type",
    sortable: true,
    filter: true,
    filterField: "classCode",
    filterPlaceholder: "Search",
    style: { minWidth: '12rem' },
  },

  {
    field: "classCodeDes",
    header: "Description",
    sortable: true,
    filter: true,
    filterField: "classCodeDes",
    filterPlaceholder: "Search",
    style: { minWidth: '12rem' },
  },

];

export const getLocalStoreColumns = (): ColumnProps[] => [
  {
    field: "localStoreId",
    header: "Id",
    sortable: true,
    filter: true,
    filterField: "localStoreId",
    filterPlaceholder: "Search",
    style: { minWidth: '12rem' }
  },
  {
    field: "localStore",
    header: "Local Store",
    sortable: true,
    filter: true,
    filterField: "localStore",
    filterPlaceholder: "Search",
    style: { minWidth: '12rem' },
  },
];


export const getUnitColumns = (): ColumnProps[] => [
  {
    field: "unitId",
    header: "Id",
    sortable: true,
    filter: true,
    filterField: "unitId",
    filterPlaceholder: "Search",
    style: { minWidth: '12rem' }
  },
  {
    field: "unitName",
    header: "Unit Name",
    sortable: true,
    filter: true,
    filterField: "unitName",
    filterPlaceholder: "Search",
    style: { minWidth: '12rem' },
  },
]


export const getFaultColumns = (
  actionBodyTemplate: (rowData: faultTypes) => JSX.Element,
  renderNameWithStatus: (rowData: faultTypes) => JSX.Element
): ColumnProps[] => [
    //   {
    //   field: "faultStatus",
    //   header: "Fault Status",
    //   body: renderFaultStatus,
    //   sortable: false,
    //   filter: false,
    //   filterField: "faultStatus",
    //   filterPlaceholder: "Search",
    //  },
    {
      selectionMode: "multiple",
      exportable: false,
    },

    {
      field: "faultId",
      header: "ID",
      sortable: false,
      filter: false,
      filterField: "faultId",
      filterPlaceholder: "Search",
    },

    {
      field: "name",
      header: "Created by",
      body: renderNameWithStatus,
      sortable: false,
      filter: false,
      filterField: "name",
      filterPlaceholder: "Search",
    },

    {
      field: "edit_user_id.name",
      header: "Last Edited By",
      sortable: false,
      filter: false,
      filterField: "edit_user_id.name",
      filterPlaceholder: "Search",
    },
    {
      field: "date",
      header: "Created Date",
      sortable: false,
      filter: false,
      filterField: "date",
      filterPlaceholder: "Search",
      body: (rowData: any) => formatDate(rowData.date),
    },
    {
      field: "fixedDate",
      header: "Edited Date",
      sortable: false,
      filter: false,
      filterField: "fixedDate",
      filterPlaceholder: "Search",
      body: (rowData: any) => formatDate(rowData.fixedDate),
    },

    {
      field: "countryName",
      header: "Country",
      sortable: false,
      filter: false,
      filterField: "countryName",
      filterPlaceholder: "Search",
    },
    {
      field: "regionName",
      header: "Region",
      sortable: false,
      filter: false,
      filterField: "regionName",
      filterPlaceholder: "Search",
    },
    {
      field: "projectName",
      header: "Project",
      sortable: false,
      filter: false,
      filterField: "projectName",
      filterPlaceholder: "Search",
    },

    {
      field: "familyName",
      header: "Family",
      sortable: false,
      filter: false,
      filterField: "familyName",
      filterPlaceholder: "Search",
    },
    {
      field: "assetName",
      header: "Asset Name",
      sortable: false,
      filter: false,
      filterField: "assetName",
      filterPlaceholder: "Search",
    },
    {
      field: "hourMeter",
      header: "Hour Meter",
      sortable: false,
      filter: false,
      filterField: "hourMeter",
      filterPlaceholder: "Search",
    },
    {
      field: "fault",
      header: "Fault",
      sortable: false,
      filter: false,
      filterField: "fault",
      filterPlaceholder: "Search",
    },
    {
      field: "worksite",
      header: "Worksite",
      sortable: false,
      filter: false,
      filterField: "worksite",
      filterPlaceholder: "Search",
    },

    {
      field: "fixedUserNames",
      header: "Fixed user",
      sortable: false,
      filter: false,
      filterField: "fixedUserNames",
      filterPlaceholder: "Search",
    },
    {
      field: "partsUsed",
      header: "Parts Used",
      sortable: false,
      filter: false,
      filterField: "partsUsed",
      filterPlaceholder: "Search",
    },
    {
      field: "workCarriedOut",
      header: "Work Carried Out",
      sortable: false,
      filter: false,
      filterField: "workCarriedOut",
      filterPlaceholder: "Search",
    },
    {
      field: "faultStatus",
      header: "Fault Status",
      sortable: false,
      filter: false,
      filterField: "faultStatus",
      filterPlaceholder: "Search",
    },
    {
      field: "hoursSpent",
      header: "Hours Spent",
      sortable: false,
      filter: false,
      filterField: "hoursSpent",
      filterPlaceholder: "Search",
    },
    {
      field: "categoryName",
      header: "Category Name",
      sortable: false,
      filter: false,
      filterField: "categoryName",
      filterPlaceholder: "Search",
    },
    {
      body: actionBodyTemplate,
      exportable: false,
    }
  ];




export const getStockSearchAndExportDataa = (
  globalFilterValue: string,
  onGlobalFilterChange: (e: React.ChangeEvent<HTMLInputElement>) => void,
  fromDate: Date | null,
  toDate: Date | null,
  onFromDateChange: (e: Date | null) => void,
  onToDateChange: (e: Date | null) => void,
  exportCSV: (data: any) => void
) => ({
  inputField: {
    iconPosition: "left",
    placeholder: "Search",
    value: globalFilterValue,
    onChange: onGlobalFilterChange,
  },
  fromDateField: {
    placeholder: "From Date",
    value: fromDate,
    onChange: (e: any) => onFromDateChange(e.value),
    showIcon: true,
    dateFormat: "yy-mm-dd",
  },
  toDateField: {
    placeholder: "To Date",
    value: toDate,
    onChange: (e: any) => onToDateChange(e.value),
    showIcon: true,
    dateFormat: "yy-mm-dd",
  },
  headerButtons: [
    {
      label: "Export",
      icon: "pi pi-upload",
      style: { marginLeft: "2px", borderRadius: "3px" },
      onClick: exportCSV,
      outlined: true,
      text: true,
      raised: true,
      title: "Export Excel",
    },
  ],
});



export const getLogisticsButtonData = (
  clearFilter: () => void,
  overlayPanelRef: React.RefObject<any>,
  selectedProducts: any[],
  handleAddLogistics: () => void,
  openVisibilityPopover: (event: React.MouseEvent<HTMLElement>) => Promise<void>,
  userDetails: { role: string[] }

): ButtonProps[] => [
    {
      type: "button",
      outlined: false,
      icon: "pi pi-filter-slash",
      label: "Clear",
      style: { marginRight: "2px", borderRadius: "3px", color: "#FFFFFF" },
      onClick: clearFilter, // Assign onClick for Clear
      title: "Clear Filter",
      text: true,
      raised: true,
    },
    ...(userDetails.role.includes("Admin") || userDetails.role.includes("Logistics Write")
      ? [
        {
          label: "Add",
          icon: "pi pi-plus",
          severity: "success" as const,
          style: { marginRight: "2px", borderRadius: "3px" },
          onClick: handleAddLogistics,
          title: "Add New Logistics",
          outlined: false,
          text: true,
          raised: true,
        },
      ]
      : []),

    {
      type: "button",

      label: "Columns",
      icon: "pi pi-list",
      style: { marginRight: "2px", borderRadius: "3px" },
      onClick: (event: React.MouseEvent<HTMLElement>) => openVisibilityPopover(event), // Pass event to openVisibilityPopover

      title: "Select Columns",
      outlined: false,
      text: true,
      raised: true,
    }
  ];

export const getTimesheetButtonData = (
  clearFilter: () => void,
  overlayPanelRef: React.RefObject<any>,
  selectedProducts: any[],
  handleAddTimesheet: () => void,
  openVisibilityPopover: (event: React.MouseEvent<HTMLElement>) => Promise<void>,
  userDetails: { role: string[] }

): ButtonProps[] => [
    {
      type: "button",
      outlined: false,
      icon: "pi pi-filter-slash",
      label: "Clear",
      style: { marginRight: "2px", borderRadius: "3px", color: "#FFFFFF" },
      onClick: clearFilter, // Assign onClick for Clear
      title: "Clear Filter",
      text: true,
      raised: true,
    },
    ...(userDetails.role.includes("Admin") ||
      userDetails.role.includes("Logistics Write")
      ? [
        {
          label: "Add",
          icon: "pi pi-plus",
          severity: "success" as const,
          style: { marginRight: "2px", borderRadius: "3px" },
          onClick: handleAddTimesheet,
          title: "Add New Logistics",
          outlined: false,
          text: true,
          raised: true,
        },
      ]
      : []),

    {
      type: "button",

      label: "Columns",
      icon: "pi pi-list",
      style: { marginRight: "2px", borderRadius: "3px" },
      onClick: (event: React.MouseEvent<HTMLElement>) => openVisibilityPopover(event), // Pass event to openVisibilityPopover

      title: "Select Columns",
      outlined: false,
      text: true,
      raised: true,
    }
  ];

export const getLogisticsColumns = (
  actionBodyTemplate: (rowData: FormValues) => JSX.Element,
  renderTitleWithStatus: (rowData: FormValues) => JSX.Element,
): ColumnProps[] => [
    {
      selectionMode: "multiple",
      exportable: false,
    },
    {
      field: 'title',
      header: 'Title',
      sortable: true,
      filter: false,
      filterField: 'title',
      filterPlaceholder: 'Search',
      body: renderTitleWithStatus, // <-- added custom renderer
    },
    {
      field: 'statusInfo',
      header: 'Status',
      sortable: true,
      filter: false,
      filterField: 'statusInfo',
      filterPlaceholder: 'Search',
    },
    {
      field: 'createdUserName',
      header: 'Created By',
      sortable: true,
      filter: false,
      body: (rowData: any) => rowData.createdUserName || '-',
    },
    {
      field: 'editedUserName',
      header: 'Edited By',
      sortable: true,
      filter: false,
      body: (rowData: any) => rowData.editedUserName || '-',
    },
    {
      field: 'createdDate',
      header: 'Created Date',
      sortable: true,
      filter: false,
      body: (rowData: any) =>
        rowData.createdDate ? formatDate(rowData.createdDate) : '-',
    },
    {
      field: 'lastUpdatedDate',
      header: 'Last Updated Date',
      sortable: true,
      filter: false,
      body: (rowData: any) =>
        rowData.lastUpdatedDate ? formatDate(rowData.lastUpdatedDate) : '-',
    },
    {
      field: 'dateOfDispatch',
      header: 'Date of Dispatch',
      sortable: true,
      filter: false,
      filterField: 'dateOfDispatch',
      filterPlaceholder: 'Search',
      body: (rowData: any) =>
        rowData.dateOfDispatch ? formatDate(rowData.dateOfDispatch) : '-',
    },
    {
      field: 'fromCountryName',
      header: 'From Country',
      sortable: true,
      filter: false,
      filterField: 'fromCountryName',
      filterPlaceholder: 'Search',
    },
    {
      field: 'fromSupplierName',
      header: 'From Supplier',
      sortable: true,
      filter: false,
      filterField: 'fromSupplierName',
      filterPlaceholder: 'Search',
    },
    {
      field: 'dateOfArrival',
      header: 'Date of Arrival',
      sortable: true,
      filter: false,
      filterField: 'dateOfArrival',
      filterPlaceholder: 'Search',
      body: (rowData: any) =>
        rowData.dateOfArrival ? formatDate(rowData.dateOfArrival) : '-',
    },
    {
      field: 'toCountryName',
      header: 'To Country',
      sortable: true,
      filter: false,
      filterField: 'toCountryName',
      filterPlaceholder: 'Search',
    },
    {
      field: 'toSupplierName',
      header: 'To Supplier',
      sortable: true,
      filter: false,
      filterField: 'toSupplierName',
      filterPlaceholder: 'Search',
    },
    {
      field: 'itemDescription',
      header: 'Item Description',
      sortable: true,
      filter: false,
      filterField: 'itemDescription',
      filterPlaceholder: 'Search',
    },
    {
      field: 'transportName',
      header: 'Transport',
      sortable: true,
      filter: false,
      filterField: 'transportName',
      filterPlaceholder: 'Search',
    },
    {
      field: 'transporterName',
      header: 'Transporter',
      sortable: true,
      filter: false,
      filterField: 'transporterName',
      filterPlaceholder: 'Search',
    },
    {
      field: 'costAllocationName',
      header: 'Cost Allocation',
      sortable: true,
      filter: false,
      filterField: 'costAllocationName',
      filterPlaceholder: 'Search',
    },
    {
      field: 'costAllocationDetails',
      header: 'Cost Allocation Details',
      sortable: true,
      filter: false,
      filterField: 'costAllocationDetails',
      filterPlaceholder: 'Search',
    },
    {
      field: 'comments',
      header: 'Comments',
      sortable: true,
      filter: false,
      filterField: 'comments',
      filterPlaceholder: 'Search',
    },


    {
      header: 'Actions',
      body: actionBodyTemplate,
      exportable: false,
    },
  ];

export const getTimesheetColumns = (
  actionBodyTemplate: (rowData: any) => JSX.Element,
  renderTitleWithStatus?: (rowData: any) => JSX.Element
): ColumnProps[] => [
    {
      selectionMode: "multiple",
      exportable: false,
    },
    {
      field: "timeSheetId",
      header: "Timesheet ID",
      sortable: true,
      filter: false,
      body: (rowData: any) => rowData.timeSheetId ?? "-",
    },
    {
      field: "period",
      header: "Period",
      sortable: true,
      filter: true,
      body: (rowData: any) => {
        if (rowData.month && rowData.year) {
          return `${rowData.month}-${rowData.year}`;
        }
        return ""; // ✅ empty string if null / ""
      },
    },
    {
      field: "totalHours",
      header: "Total Hours",
      sortable: true,
      filter: true,
      filterField: "totalHours",
      filterPlaceholder: "Search by Project",
      body: (rowData: any) => rowData.totalHours || "-",
    },


    {
      field: "projectName",
      header: "Project",
      sortable: true,
      filter: true,
      filterField: "projectName",
      filterPlaceholder: "Search by Project",
      body: (rowData: any) => rowData.projectName || "-",
    },
    {
      field: "regionName",
      header: "Region",
      sortable: true,
      filter: true,
      filterField: "regionName",
      filterPlaceholder: "Search by Region",
      body: (rowData: any) => rowData.regionName || "-",
    },
    {
      field: "countryName",
      header: "Country",
      sortable: true,
      filter: true,
      filterField: "countryName",
      filterPlaceholder: "Search by Country",
      body: (rowData: any) => rowData.countryName || "-",
    },
    {
      field: "type",
      header: "Type",
      sortable: true,
      filter: true,
      filterField: "type",
      filterPlaceholder: "Search by Type",
      body: (rowData: any) => rowData.type || "-",
    },
    {
      field: "fromdate",
      header: "From Date",
      sortable: true,
      filter: false,
      body: (rowData: any) =>
        rowData.fromdate ? formatDate(rowData.fromdate) : "-",
    },
    {
      field: "todate",
      header: "To Date",
      sortable: true,
      filter: false,
      body: (rowData: any) =>
        rowData.todate ? formatDate(rowData.todate) : "-",
    },
    {
      field: "rigs",
      header: "Rigs",
      sortable: false,
      filter: false,
      body: (rowData: any) => {
        const rigs = rowData.rigs ?? [];
        if (rigs.length === 0) return "No Rigs";

        // Get rig names
        const rigNames = rigs.map((r: any) => r.rigName).join(", ");

        return `${rigs.length} Rig${rigs.length > 1 ? "s" : ""} — ${rigNames}`;
      },
    },
    {
      field: "status",
      header: "Status",
      sortable: true,
      filter: true,
      body: (rowData: any) => {
        if (rowData.status === 1) return "Submitted";
        if (rowData.status === 0) return "Saved (Draft)";
        return "-";
      },
    },
    {
      header: "Actions",
      body: actionBodyTemplate,
      exportable: false,
    },
  ];


export const logisticsBodyTableIcon = (
  handleEditLogistics: (logisticsId: number, rowData: FormValues) => void,
  handleDeleteLogistics: (logisticsId: number) => void,
  rowData: FormValues
): ButtonProps[] => [
    {
      icon: "pi pi-pencil",
      rounded: true,
      outlined: true,
      className: "mr-2",
      onClick: () => handleEditLogistics(rowData.logisticsId, rowData),
      title: "Edit Asset",
    },
    {
      icon: "pi pi-trash",
      rounded: true,
      outlined: true,
      className: "mr-2",
      severity: 'danger',
      onClick: () => handleDeleteLogistics(rowData.logisticsId),
      title: "Delete Asset",
    }
    ////////

  ]

export const timesheetBodyTableIcon = (
  handleEditLogistics: (logisticsId: number, rowData: FormValues) => void,

  rowData: any
): ButtonProps[] => [
    {
      icon: "pi pi-pencil",
      rounded: true,
      outlined: true,
      className: "mr-2",
      onClick: () => handleEditLogistics(rowData.timeSheetId, rowData),
      title: "Edit Asset",
    },

    ////////

  ]
export const getTemplateColumnColumns = (): ColumnProps[] => [
  {
    field: "templateColumnId",
    header: "Id",
    sortable: true,
    filter: true,
    filterField: "templateColumnId",
    filterPlaceholder: "Search",
    style: { minWidth: '12rem' }
  },
  {
    field: "templateColumnName",
    header: "Template Column Name",
    sortable: true,
    filter: true,
    filterField: "templateColumnName",
    filterPlaceholder: "Search",
    style: { minWidth: '12rem' },
  },
];


export const getInspectionColumnColumns = (): ColumnProps[] => [
  {
    field: "inspectionColumnId",
    header: "Id",
    sortable: true,
    filter: true,
    filterField: "inspectionColumnId",
    filterPlaceholder: "Search",
    style: { minWidth: '12rem' }
  },
  {
    field: "inspectionColumnName",
    header: "Inspection Column Name",
    sortable: true,
    filter: true,
    filterField: "inspectionColumnName",
    filterPlaceholder: "Search",
    style: { minWidth: '12rem' },
  },
];


export const getToolsColumns = (): ColumnProps[] => [
  {
    field: "toolsId",
    header: "Id",
    sortable: true,
    filter: true,
    filterField: "toolsId",
    filterPlaceholder: "Search",
    style: { minWidth: '12rem' }
  },
  {
    field: "toolsName",
    header: "Tools Name",
    sortable: true,
    filter: true,
    filterField: "toolsName",
    filterPlaceholder: "Search",
    style: { minWidth: '12rem' },
  },
];



export const getEquipmentColumns = (): ColumnProps[] => [
  {
    field: "equipmentId",
    header: "Id",
    sortable: true,
    filter: true,
    filterField: "equipmentId",
    filterPlaceholder: "Search",
    style: { minWidth: '12rem' }
  },
  {
    field: "equipmentName",
    header: "Equipment Name",
    sortable: true,
    filter: true,
    filterField: "equipmentName",
    filterPlaceholder: "Search",
    style: { minWidth: '12rem' },
  },
];


export const getModelColumns = (): ColumnProps[] => [
  {
    field: "modelId",
    header: "Id",
    sortable: true,
    filter: true,
    filterField: "modelId",
    filterPlaceholder: "Search",
    style: { minWidth: '12rem' }
  },
  {
    field: "modelName",
    header: "Name",
    sortable: true,
    filter: true,
    filterField: "modelName",
    filterPlaceholder: "Search",
    style: { minWidth: '12rem' },
  },
];

export const getCostAllocationColumns = (): ColumnProps[] => [
  {
    field: "costAllocationId",
    header: "Id",
    sortable: true,
    filter: true,
    filterField: "costAllocationId",
    filterPlaceholder: "Search",
    style: { minWidth: '12rem' }
  },
  {
    field: "costAllocationName",
    header: "Name",
    sortable: true,
    filter: true,
    filterField: "costAllocationName",
    filterPlaceholder: "Search",
    style: { minWidth: '12rem' },
  },
];

export const getTransporterColumns = (): ColumnProps[] => [
  {
    field: "transporterId",
    header: "Id",
    sortable: true,
    filter: true,
    filterField: "transporterId",
    filterPlaceholder: "Search",
    style: { minWidth: '12rem' }
  },
  {
    field: "transporterName",
    header: "Transporter Name",
    sortable: true,
    filter: true,
    filterField: "transporterName",
    filterPlaceholder: "Search",
    style: { minWidth: '12rem' },
  },
];

export const getSupplierColumns = (): ColumnProps[] => [
  {
    field: "supplierId",
    header: "Id",
    sortable: true,
    filter: true,
    filterField: "supplierId",
    filterPlaceholder: "Search",
    style: { minWidth: '12rem' }
  },
  {
    field: "supplierName",
    header: "Supplier Name",
    sortable: true,
    filter: true,
    filterField: "supplierName",
    filterPlaceholder: "Search",
    style: { minWidth: '12rem' },
  },
];

export const getServiceTypeColumns = (): ColumnProps[] => [
  {
    field: "serviceTypeId",
    header: "Id",
    sortable: true,
    filter: true,
    filterField: "serviceTypeId",
    filterPlaceholder: "Search",
    style: { minWidth: '12rem' }
  },
  {
    field: "serviceTypeName",
    header: "Service Type Name",
    sortable: true,
    filter: true,
    filterField: "serviceTypeName",
    filterPlaceholder: "Search",
    style: { minWidth: '12rem' },
  },
];


export const getInpectionTypeColumns = (): ColumnProps[] => [
  {
    field: "inspectionTypeId",
    header: "Id",
    sortable: true,
    filter: true,
    filterField: "inspectionTypeId",
    filterPlaceholder: "Search",
    style: { minWidth: '12rem' }
  },
  {
    field: "inspectionTypeName",
    header: "Inpection Type Name",
    sortable: true,
    filter: true,
    filterField: "inspectionTypeName",
    filterPlaceholder: "Search",
    style: { minWidth: '12rem' },
  },
];









